import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MdLanguage } from 'react-icons/md';
import { trackEvent } from '../utils/analytics';

function Footer({ basePath = '' }) {
    const { t, i18n } = useTranslation();
    const currentLang = (i18n.language || 'es').substring(0, 2).toLowerCase();

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
        trackEvent({
            category: 'Language',
            action: 'change_language',
            label: lang,
        });
    };

    return (
        <footer className="footer-main">
            <div className="footer-top">

                {/* LEFT */}
                <div className="footer-top-left">
                    <div className="footer-logo">
                        <img
                            src={process.env.PUBLIC_URL + '/sources/logo/logo3.webp'}
                            alt="MCE"
                            style={{ height: '40px', filter: 'invert(1)' }}
                        />
                    </div>
                </div>

                {/* RIGHT */}
                <div className="footer-top-right">
                    <h3>{t('footer.contactus')}</h3>

                    {/* Phone + Email ROW */}
                    <div className="footer-contact-row">
                        <p>
                            <strong>{t('footer.phone')}:</strong>
                            <a
                                href="tel:+34696360968"
                                onClick={() =>
                                    trackEvent({
                                        category: 'Contact',
                                        action: 'click_phone',
                                        label: 'Footer Phone Link',
                                    })
                                }
                            >
                                +34 696 36 09 68
                            </a>
                        </p>

                        <p>
                            <strong>{t('footer.email')}:</strong>
                            <a
                                href="mailto:negocio@mcegrupoinversor.es"
                                onClick={() =>
                                    trackEvent({
                                        category: 'Contact',
                                        action: 'click_email',
                                        label: 'Footer Email Link',
                                    })
                                }
                            >
                                negocio@mcegrupoinversor.es
                            </a>
                        </p>
                    </div>

                    {/* Address BELOW */}
                    <p className="footer-address">
                        <strong>{t('footer.address')}:</strong>
                        Calle de Francisco Silvela 71. 28028. Madrid
                    </p>
                </div>
            </div>

            {/* BOTTOM */}
            <div className="footer-bottom">
                <div className="footer-bottom-left">
                    <p>{t('footer.copyright')}</p>
                </div>

                <div className="footer-lang-switcher">
                    <MdLanguage className="lang-icon" />
                    <span className="lang-label">{t('footer.language')}:</span>
                    <button
                        type="button"
                        className={`lang-btn ${currentLang === 'es' ? 'active' : ''}`}
                        onClick={() => changeLanguage('es')}
                        aria-label="Cambiar idioma a Español"
                        aria-pressed={currentLang === 'es'}
                    >
                        ES
                    </button>
                    <span className="lang-divider">|</span>
                    <button
                        type="button"
                        className={`lang-btn ${currentLang === 'en' ? 'active' : ''}`}
                        onClick={() => changeLanguage('en')}
                        aria-label="Switch language to English"
                        aria-pressed={currentLang === 'en'}
                    >
                        EN
                    </button>
                </div>

                <div className="footer-bottom-right">
                    <Link to={`${basePath}/politica/privacidad`}>
                        {t('footer.privacyPolicy')}
                    </Link>
                    <span> | </span>

                    <Link to={`${basePath}/politica/terminos`}>
                        {t('footer.termsAndConditions')}
                    </Link>
                    <span> | </span>

                    <Link to={`${basePath}/politica/cookies`}>
                        {t('footer.cookiePolicy')}
                    </Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;